<div fxLayoutAlign="start center" [style.color]="'var(--content-color, var(--ion-color-primary))'">
  <mat-icon *ngIf="count">description</mat-icon>
  <span *ngIf="count || !hideZeroValue" [style.margin-left.px]="count ? 4 : 28">
    {{count}}
  </span>
</div>